import React from "react";

import Grid from "@busbud/design-system-components/dist/Grid/Grid";

import { useAppContext } from "@app/helpers/hooks";

import { COVERED, HepstarTermChip } from "./hepstar-terms-chip";

export const HepstarTermsCoveredChips = () => {
  const { translator } = useAppContext();

  return (
    <Grid container xSpacing={6}>
      <Grid item xs={24} md={12}>
        <HepstarTermChip
          category={COVERED}
          label={translator.t("!ancillary.hepstar.terms.covered.ilness")}
        />
        <HepstarTermChip
          category={COVERED}
          label={translator.t(
            "!ancillary.hepstar.terms.covered.existing-medical-condition"
          )}
        />
        <HepstarTermChip
          category={COVERED}
          label={translator.t(
            "!ancillary.hepstar.terms.covered.pregnancy-complication"
          )}
        />
        <HepstarTermChip
          category={COVERED}
          label={translator.t("!ancillary.hepstar.terms.covered.family-deat")}
        />
        <HepstarTermChip
          category={COVERED}
          label={translator.t(
            "!ancillary.hepstar.terms.covered.public-transport-failure"
          )}
        />
        <HepstarTermChip
          category={COVERED}
          label={translator.t(
            "!ancillary.hepstar.terms.covered.flight-disruption"
          )}
        />
        <HepstarTermChip
          category={COVERED}
          label={translator.t(
            "!ancillary.hepstar.terms.covered.mechanical-breakdown"
          )}
        />
        <HepstarTermChip
          category={COVERED}
          label={translator.t(
            "!ancillary.hepstar.terms.covered.adverse-weather"
          )}
        />
      </Grid>
      <Grid item xs={24} md={12}>
        <HepstarTermChip
          category={COVERED}
          label={translator.t(
            "!ancillary.hepstar.terms.covered.home-emergency"
          )}
        />
        <HepstarTermChip
          category={COVERED}
          label={translator.t(
            "!ancillary.hepstar.terms.covered.theft-documents"
          )}
        />
        <HepstarTermChip
          category={COVERED}
          label={translator.t("!ancillary.hepstar.terms.covered.jury-service")}
        />
        <HepstarTermChip
          category={COVERED}
          label={translator.t("!ancillary.hepstar.terms.covered.court")}
        />
        <HepstarTermChip
          category={COVERED}
          label={translator.t("!ancillary.hepstar.terms.covered.armed-forces")}
        />
        <HepstarTermChip
          category={COVERED}
          label={translator.t(
            "!ancillary.hepstar.terms.covered.relocated-work"
          )}
        />
        <HepstarTermChip
          category={COVERED}
          label={translator.t("!ancillary.hepstar.terms.covered.exams-dates")}
        />
      </Grid>
    </Grid>
  );
};
